'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { KNOWN_FEATURES } from 'src/constants/features';
import { USER_ONBOARDED } from 'src/constants/session';
import useAppStorage from './useAppStorage';
import useFeatures from './useFeatures';
import posthog from 'posthog-js';
const useUserOnboarded = () => {
  const $ = _c(8);
  const {
    getItem,
    setItem
  } = useAppStorage();
  const {
    isEnabled
  } = useFeatures();
  let t0;
  if ($[0] !== getItem || $[1] !== isEnabled) {
    t0 = getItem(USER_ONBOARDED) === "true" || isEnabled(KNOWN_FEATURES.SKIP_ONBOARDING);
    $[0] = getItem;
    $[1] = isEnabled;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const isUserOnboarded = t0;
  let t1;
  if ($[3] !== setItem) {
    t1 = () => {
      setItem(USER_ONBOARDED, "true");
      posthog.capture("first_dashboard_view");
    };
    $[3] = setItem;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const markUserAsOnboarded = t1;
  let t2;
  if ($[5] !== isUserOnboarded || $[6] !== markUserAsOnboarded) {
    t2 = {
      isUserOnboarded,
      markUserAsOnboarded
    };
    $[5] = isUserOnboarded;
    $[6] = markUserAsOnboarded;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default useUserOnboarded;